import React, { memo } from 'react'
import { Button, Flex } from '@chakra-ui/react'

function ActionButtonComponent({
  onClick,
  isDisabled = false,
  isLoading = false,
  loadingText = 'Processando...',
  children,
  width = '200px',
  position = 'fixed',
  type = 'button',
}) {
  return (
    <Flex
      position={position === 'fixed' ? 'fixed' : 'relative'}
      bottom={position === 'fixed' ? '0' : 'auto'}
      left={position === 'fixed' ? '0' : 'auto'}
      right={position === 'fixed' ? '0' : 'auto'}
      justifyContent="center"
      zIndex={position === 'fixed' ? '10' : 'auto'}
      mt={position === 'static' ? 8 : 0}
      mb={position === 'static' ? 4 : 0}
      bg={position === 'fixed' ? 'white' : 'transparent'}
      py={position === 'fixed' ? 4 : 0}
      borderTopWidth={position === 'fixed' ? '1px' : '0'}
      borderTopColor="gray.200"
      boxShadow={position === 'fixed' ? '0px -2px 10px rgba(0, 0, 0, 0.05)' : 'none'}
    >
      <Button
        onClick={onClick}
        isDisabled={isDisabled}
        isLoading={isLoading}
        loadingText={loadingText}
        bg="#378BBF"
        _hover={{ bg: '#2a6a8f' }}
        _active={{ bg: '#1d4d6b' }}
        color="white"
        size="lg"
        width={width}
        type={type}
      >
        {children}
      </Button>
    </Flex>
  )
}

export const ActionButton = memo(ActionButtonComponent)
